module.exports = __webpack_public_path__ + "static/media/d.f438b2e0.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/component/sounds/d.mp3
// module id = 93
// module chunks = 0